import { FC } from 'react';
import CommonPage from '../components/page/CommonPage';
import TerminalList from '../components/terminal/TerminalList';

const DeviceListPage : FC= () => {

    return (
        <CommonPage selectBtnIndex={2} >
            <TerminalList />
        </CommonPage>
    )
}

export default DeviceListPage;